<template>
  <div class="wrapper">
    <!-- 标题区域 -->
    <div class="page-header">
      <div class="header-content">
        <h2 class="page-title">
          <i class="el-icon-s-order title-icon"></i>
          {{ $route.meta.name }}
        </h2>
        <div class="header-stats">
          <div class="stat-item">
            <span class="stat-label">总记录数</span>
            <span class="stat-value">{{ total }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 搜索区域 -->
    <el-card class="search-card" shadow="never">
      <div class="card-header-title">
        <i class="el-icon-search"></i>
        <span>筛选条件</span>
      </div>
      <div class="header-search">
      <el-form
        inline
        class="search-header"
        :model="searchData"
        label-width="110px"
      >
      <el-form-item label="关键字" class="kw">
        <el-input
          placeholder="请输入"
          v-model="searchData.keywordValue"
          class="input-with-select"
          size="small"
        >
          <el-select
            v-model="searchData.keywordName"
            slot="prepend"
            placeholder="请选择"
            size="small"
          >
            <el-option
              v-for="item in searchTypeBill"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item label="订单类型">
        <el-select
          style="width: 180px"
          v-model="searchData.orderType"
          placeholder="请选择"
          size="small"
          clearable
        >
          <el-option
            v-for="item in dict_order_type"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="下单时间">
        <el-date-picker
          style="width: 300px"
          size="small"
          v-model="searchData.timeSlotOrder"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item label="期数">
        <el-input-number
          placeholder="请输入"
          size="small"
          style="width: 150px"
          v-model="searchData.leftBillNum"
          :step="1"
          :min="null"
          step-strictly
          controls-position="right"
        />
        <span> 至 </span>
        <el-input-number
          placeholder="请输入"
          size="small"
          style="width: 150px"
          v-model="searchData.rightBillNum"
          :step="1"
          :min="null"
          step-strictly
          controls-position="right"
        />
      </el-form-item>
      <el-form-item label="账单日">
        <el-date-picker
          style="width: 300px"
          size="small"
          v-model="searchData.timeSlotBill"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select
          style="width: 180px"
          v-model="searchData.orderStatusList"
          placeholder="请选择"
          size="small"
          clearable
          multiple
        >
          <el-option
            v-for="item in orderStatus2"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="租金支付类型">
        <SelectDict
          width="180px"
          v-model="searchData.principalPayMode"
          dictCode="pay:mode"
        />
      </el-form-item>
      <el-form-item label="是否预付">
        <el-select
          style="width: 180px"
          v-model="searchData.isPrepay"
          placeholder="请选择"
          size="small"
          clearable
        >
          <el-option label="否" :value="false" />
          <el-option label="是" :value="true" />
        </el-select>
      </el-form-item>
      <el-form-item label="支付完成时间">
        <el-date-picker
          style="width: 300px"
          size="small"
          v-model="searchData.timeSlotFinal"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item label="账单逾期天数">
        <el-input-number
          placeholder="请输入"
          size="small"
          style="width: 150px"
          v-model="searchData.leftOverdueDayNum"
          :step="1"
          :min="null"
          step-strictly
          controls-position="right"
        />
        <span> 至 </span>
        <el-input-number
          placeholder="请输入"
          size="small"
          style="width: 150px"
          v-model="searchData.rightOverdueDayNum"
          :step="1"
          :min="null"
          step-strictly
          controls-position="right"
        />
      </el-form-item>
      <el-form-item label="客户逾期天数">
        <el-input-number
          placeholder="请输入"
          size="small"
          style="width: 150px"
          v-model="searchData.leftMemberOverdueDayNum"
          :step="1"
          :min="null"
          step-strictly
          controls-position="right"
        />
        <span> 至 </span>
        <el-input-number
          placeholder="请输入"
          size="small"
          style="width: 150px"
          v-model="searchData.rightMemberOverdueDayNum"
          :step="1"
          :min="null"
          step-strictly
          controls-position="right"
        />
      </el-form-item>
      <el-form-item label="设备锁状态">
        <el-select
          style="width: 180px"
          v-model="searchData.lockStatus"
          placeholder="请选择"
          size="small"
          clearable
        >
          <el-option label="未上锁" :value="0" />
          <el-option label="待上锁" :value="1" />
          <el-option label="已上锁" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="待上锁日期">
        <el-date-picker
          style="width: 300px"
          v-model="searchData.timeSlotLock"
          size="small"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item label="门店BD">
        <el-input
          placeholder="请输入"
          size="small"
          style="width: 180px"
          v-model="searchData.storeBusinessUserName"
        />
      </el-form-item>
      <el-form-item label="是否首期非首付">
        <el-select
          style="width: 180px"
          v-model="searchData.isFupBill"
          placeholder="请选择"
          size="small"
          clearable
        >
          <el-option label="否" :value="false" />
          <el-option label="是" :value="true" />
        </el-select>
      </el-form-item>
      <el-form-item label=" " label-width="50px">
        <el-button
          @click="getList"
          type="primary"
          icon="el-icon-search"
          size="small"
          class="search-btn"
        >
          查询
        </el-button>
        <el-button
          @click="reset"
          size="small"
          type="info"
          icon="el-icon-refresh"
          class="reset-btn"
        >
          重置
        </el-button>
      </el-form-item>
      </el-form>
      </div>
    </el-card>

    <div class="header-container" v-if="false">
      <div class="left">
        <el-form
          inline
          class="search-header"
          :model="searchData"
          label-width="80px"
        >
          <el-form-item label="关键字" class="keywords">
            <el-input
              placeholder="请输入"
              v-model="searchData.keywordValue"
              class="input-with-select"
              size="small"
            >
              <el-select
                v-model="searchData.keywordName"
                slot="prepend"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in searchTypeBill"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-select
              style="width: 350px"
              v-model="searchData.orderType"
              placeholder="请选择"
              size="small"
              clearable
            >
              <el-option
                v-for="item in dict_order_type"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="租金支付类型" class="pay-type">
            <SelectDict
              v-model="searchData.principalPayMode"
              dictCode="pay:mode"
            />
          </el-form-item>
          <el-form-item label="账单日">
            <el-date-picker
              style="width: 350px"
              size="small"
              v-model="searchData.timeSlotBill"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="支付完成时间">
            <el-date-picker
              style="width: 350px"
              size="small"
              v-model="searchData.timeSlotFinal"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="账单逾期天数" v-show="isShow">
            <el-input-number
              placeholder="请输入"
              size="small"
              style="width: 165px"
              v-model="searchData.leftOverdueDayNum"
              :step="1"
              :min="null"
              step-strictly
              controls-position="right"
            />
            <span> 至 </span>
            <el-input-number
              placeholder="请输入"
              size="small"
              style="width: 165px"
              v-model="searchData.rightOverdueDayNum"
              :step="1"
              :min="null"
              step-strictly
              controls-position="right"
            />
          </el-form-item>
          <el-form-item label="下单时间" v-show="isShow">
            <el-date-picker
              style="width: 350px"
              size="small"
              v-model="searchData.timeSlotOrder"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="订单状态" v-show="isShow">
            <el-select
              style="width: 350px"
              v-model="searchData.orderStatusList"
              placeholder="请选择"
              size="small"
              clearable
              multiple
            >
              <el-option
                v-for="item in orderStatus2"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="期数" v-show="isShow">
            <el-input-number
              placeholder="请输入"
              size="small"
              style="width: 165px"
              v-model="searchData.leftBillNum"
              :step="1"
              :min="null"
              step-strictly
              controls-position="right"
            />
            <span> 至 </span>
            <el-input-number
              placeholder="请输入"
              size="small"
              style="width: 165px"
              v-model="searchData.rightBillNum"
              :step="1"
              :min="null"
              step-strictly
              controls-position="right"
            />
          </el-form-item>
          <el-form-item label="客户逾期天数" v-show="isShow">
            <el-input-number
              placeholder="请输入"
              size="small"
              style="width: 165px"
              v-model="searchData.leftMemberOverdueDayNum"
              :step="1"
              :min="null"
              step-strictly
              controls-position="right"
            />
            <span> 至 </span>
            <el-input-number
              placeholder="请输入"
              size="small"
              style="width: 165px"
              v-model="searchData.rightMemberOverdueDayNum"
              :step="1"
              :min="null"
              step-strictly
              controls-position="right"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="right">
        <span class="open" @click="isShow = !isShow">{{ isShow ? "收起" : "展开" }}</span>
        <i class="updown" :class="['el-icon-arrow-up', isShow ? '' : 'go']"></i>
        <el-button
          style="margin-left: 10px"
          @click="getList"
          type="primary"
          icon="el-icon-search"
          size="small"
        >
          查询
        </el-button>
        <el-button
          @click="reset"
          size="small"
          type="info"
          icon="el-icon-refresh"
        >
          重置
        </el-button>
      </div>
    </div>

    <!-- 标签页区域 -->
    <el-card class="tab-card" shadow="never">
      <div class="header-tab">
        <div class="left-tab">
          <span
            @click="searchData.activeStatus = tab.value"
            v-for="tab in billStatus"
            :key="tab.value"
            :class="[searchData.activeStatus == tab.value ? 'select-tab' : 'tab-item']"
          >
            <el-badge>
              {{ tab.name }}
            </el-badge>
          </span>
        </div>

        <div class="tab-actions">
          <el-button
            v-checkbtn="isShowBtn(AUTH_BTN.order_bill_list_today_export)"
            type="warning"
            size="small"
            @click="downloadExpiredTodayExcel"
            class="export-today-btn"
          >
            今日到期导出
          </el-button>

          <el-button
            v-checkbtn="isShowBtn(AUTH_BTN.order_bill_list_export)"
            type="primary"
            size="small"
            icon="el-icon-download"
            @click="downloadExcel"
            class="export-btn"
          >
            导出
          </el-button>
        </div>
      </div>
    </el-card>

    <!-- 表格区域 -->
    <el-card class="table-card" shadow="never">
      <div class="card-header-title">
        <i class="el-icon-s-grid"></i>
        <span>账单列表</span>
      </div>
      <tp-table
        @handleSelectionChange="handleSelectionChange"
        :isCheckBox="false"
        :tableData="list"
        :columns="columns"
        :totalNum="total"
        :current-page.sync="currentPage"
        :pageSize.sync="pageSize"
      />
    </el-card>
    <div style="height: 50px"></div>
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import { getListAPI, DownloadAPI, exportTodayExpiredBill } from "./api";
import {
  searchTypeBill,
  billStatus,
  orderStatus2,
  dict_order_type,
} from "@/enum/dict/index.js";
import SelectDict from "@/views/components/select-dict.vue";

const columns = [
  {
    label: "客户信息",
    prop: "member",
    minWidth: "180",
    customRender(h, row) {
      return (
        <div>
          <div>姓名：{row["member"]?.["memberName"]}</div>
          <div>手机号：{row["member"]?.["mobile"]}</div>
        </div>
      );
    },
  },
  {
    label: "账单状态",
    prop: "order",
    minWidth: "150",
    customRender(h, row) {
      return <p class="table-cell-text">{row["statusName"]} / {row["status2Name"]}</p>;
    },
  },
  {
    label: "订单状态",
    prop: "order",
    minWidth: "150",
    customRender(h, row) {
      return <p class="table-cell-text">{row["order"]?.["statusName"]} / {row["order"]?.["status2Name"]}</p>;
    },
  },
  {
    label: "售后状态",
    prop: "order",
    minWidth: "100",
    customRender(h, row) {
      return <p class="table-cell-text">{row["order"]?.["afterSaleStatusName"] || '-'}</p>;
    },
  },
  {
    label: "设备监管信息",
    prop: "order",
    minWidth: "180",
    customRender(h, row) {
      return (
        <p>
          <div v-show={row["order"]}>
            设备锁状态：
            <el-tag
              v-show={row["order"]["lockStatus"] == 0}
              type="success"
              size="mini"
            >
              未上锁
            </el-tag>
            <el-tag
              v-show={row["order"]["lockStatus"] == 1}
              type="warning"
              size="mini"
            >
              待上锁
            </el-tag>
            <el-tag
              v-show={row["order"]["lockStatus"] == 2}
              type="danger"
              size="mini"
            >
              已上锁
            </el-tag>
          </div>
          <div v-show={row["order"]}>
            待上锁日期：
            {row["order"]["lockDate"] || "无"}
          </div>
          <div v-show={row["order"]}>
            设备状态： {row["order"]?.["deviceStatusName"]}
          </div>
        </p>
      );
    },
  },
  {
    label: "账单逾期天数",
    prop: "overdueDayNum",
    minWidth: "120",
    customRender(h, row) {
      return <p class="table-cell-text">{row["overdueDayNum"] || '-'}</p>;
    },
  },
  {
    label: "客户在逾天数",
    prop: "memberOverdueDayNum",
    minWidth: "120",
    customRender(h, row) {
      return <p class="table-cell-text">{row["member"]?.["overdueDayNum"] || '-'}</p>;
    },
  },
  {
    label: "下单时间",
    prop: "order",
    minWidth: "180",
    customRender(h, row) {
      return <p class="table-cell-text">{row["order"]?.["createTime"] || '-'}</p>;
    },
  },
  {
    label: "期数",
    prop: "billNum",
    minWidth: "120",
    customRender(h, row) {
      return (
        <div>
          <p>
            {row["billNum"]}
            <el-tag
              style="margin-left:5px"
              v-show={row["isPrepay"]}
              type="info"
              size="mini"
            >
              预付
            </el-tag>
            <el-tag
              style="margin-left:5px"
              v-show={row["isFupBill"]}
              type="info"
              size="mini"
            >
              首期非首付
            </el-tag>
          </p>
        </div>
      );
    },
  },
  {
    label: "账单日",
    prop: "billDate",
    minWidth: "120",
    customRender(h, row) {
      return <p class="table-cell-text">{row["billDate"] || '-'}</p>;
    },
  },
  {
    label: "下期账单日",
    prop: "nextBillDate",
    minWidth: "120",
    customRender(h, row) {
      return <p class="table-cell-text">{row["nextBillDate"] || '-'}</p>;
    },
  },
  {
    label: "租金",
    prop: "principalAmount",
    minWidth: "100",
    customRender(h, row) {
      return <p class="table-cell-text">{row["principalAmount"] || '-'}</p>;
    },
  },
  {
    label: "租金支付类型",
    prop: "principalPayModeName",
    minWidth: "120",
    customRender(h, row) {
      return <p class="table-cell-text">{row["principalPayModeName"] || '-'}</p>;
    },
  },
  {
    label: "滞纳金",
    prop: "overdueAmount",
    minWidth: "100",
    customRender(h, row) {
      return <p class="table-cell-text">{row["overdueAmount"] || '-'}</p>;
    },
  },
  {
    label: "减免金额",
    prop: "offAmount",
    minWidth: "100",
    customRender(h, row) {
      return <p class="table-cell-text">{row["offAmount"] || '-'}</p>;
    },
  },
  {
    label: "待支付金额",
    prop: "leftPayAmount",
    minWidth: "100",
    customRender(h, row) {
      return <p class="table-cell-text">{row["leftPayAmount"] || '-'}</p>;
    },
  },
  {
    label: "支付完成时间",
    prop: "finalPayTime",
    minWidth: "180",
    customRender(h, row) {
      return <p class="table-cell-text">{row["finalPayTime"] || '-'}</p>;
    },
  },
  {
    label: "审核",
    prop: "reviewUser",
    minWidth: "100",
    customRender(h, row) {
      return <p class="table-cell-text">{row["reviewUser"]?.["userName"] || '-'}</p>;
    },
  },
  {
    label: "门店信息",
    prop: "Store",
    minWidth: "200",
    customRender(h, row) {
      return (
        <div>
          <div>门店名称：{row["storeName"]}</div>
          <div>门店BD：{row["storeBusinessUserName"]}</div>
        </div>
      );
    },
  },
  {
    label: "订单信息",
    prop: "order",
    minWidth: "300",
    fixed: "right",
    customRender(h, row) {
      return (
        <div>
          <div>订单号：{row["order"]?.["orderNo"]}</div>
          <div>
            订单类型：
            <el-tag v-show={row["order"]?.["orderType"] == 1} type="info" size="mini">商城订单</el-tag>
            <el-tag v-show={row["order"]?.["orderType"] == 2} type="warning" size="mini">门店3C</el-tag>
          </div>
        </div>
      );
    },
  },
];
export default {
  name: "OrderBillList",
  mixins: [authBtnMixin],
  components: { SelectDict },
  data() {
    return {
      isShow: false, //控制箭头
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        activeStatus: "0",
        keywordName: "",
        keywordValue: "",
        principalPayMode: "",
        timeSlotFinal: [],
        leftFinalPayDate: "",
        rightFinalPayDate: "",
        timeSlotBill: [],
        leftBillDate: "",
        rightBillDate: "",
        timeSlotOrder: [],
        leftOrderDate: "",
        rightOrderDate: "",
        orderStatusList: [],
        orderType: "",
        rightBillNum: "",
        leftBillNum: "",
        leftOverdueDayNum: "",
        rightOverdueDayNum: "",
        leftMemberOverdueDayNum: "",
        rightMemberOverdueDayNum: "",
        isPrepay: null,
        lockStatus: "",
        timeSlotLock: [],
        storeBusinessUserName: "",
        isFupBill: null,
      },
      // 字典
      searchTypeBill,
      billStatus,
      orderStatus2,
      dict_order_type,
      // 已勾选
      tableSelected: [],
    };
  },
  provide() {
    return {
      context: this,
    };
  },
  mounted() {
    // this.getList()
    window["getBpageList"] = () => {
      this.getList();
    };
  },
  activated() {
    this.getList();
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
    "searchData.activeStatus": {
      // immediate: true,
      handler(newV, oldV) {
        this.getList();
      },
    },
  },
  methods: {
    downloadExpiredTodayExcel() {
      exportTodayExpiredBill();
    },

    async getList() {
      const {
        timeSlotFinal,
        timeSlotBill,
        timeSlotOrder,
        keywordName,
        keywordValue,
        activeStatus,
        leftOverdueDayNum,
        rightOverdueDayNum,
        principalPayMode,
        orderStatusList,
        orderType,
        leftBillNum,
        rightBillNum,
        rightMemberOverdueDayNum,
        leftMemberOverdueDayNum,
        isPrepay,
        lockStatus,
        timeSlotLock,
        storeBusinessUserName,
        isFupBill,
      } = this.searchData;
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        leftOverdueDayNum,
        rightOverdueDayNum,
        principalPayMode,
        orderStatusList: orderStatusList.join(),
        orderType,
        leftBillNum,
        rightBillNum,
        rightMemberOverdueDayNum,
        leftMemberOverdueDayNum,
        isPrepay,
        lockStatus,
        storeBusinessUserName,
        isFupBill,
      };
      if (activeStatus != 0) params.status = activeStatus - 0;
      if (timeSlotFinal && timeSlotFinal.length > 0) {
        params.leftFinalPayDate = timeSlotFinal[0];
        params.rightFinalPayDate = timeSlotFinal[1];
      }
      if (timeSlotBill && timeSlotBill.length > 0) {
        params.leftBillDate = timeSlotBill[0];
        params.rightBillDate = timeSlotBill[1];
      }
      if (timeSlotOrder && timeSlotOrder.length > 0) {
        params.leftOrderDate = timeSlotOrder[0];
        params.rightOrderDate = timeSlotOrder[1];
      }
      if (timeSlotLock && timeSlotLock.length > 0) {
        params.leftLockDate = timeSlotLock[0];
        params.rightLockDate = timeSlotLock[1];
      }
      if (keywordName) params[keywordName] = keywordValue;
      const res = await getListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    handleSelectionChange(val) {
      this.tableSelected = val;
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      if (this.searchData.activeStatus != "0")
        return (this.searchData.activeStatus = "0");
      this.getList();
    },

    downloadExcel() {
      const {
        timeSlotFinal,
        timeSlotBill,
        timeSlotOrder,
        keywordName,
        keywordValue,
        activeStatus,
        leftOverdueDayNum,
        rightOverdueDayNum,
        principalPayMode,
        orderStatusList,
        orderType,
        leftBillNum,
        rightBillNum,
        rightMemberOverdueDayNum,
        leftMemberOverdueDayNum,
        isPrepay,
        lockStatus,
        timeSlotLock,
        storeBusinessUserName,
        isFupBill,
      } = this.searchData;
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        leftOverdueDayNum,
        rightOverdueDayNum,
        principalPayMode,
        orderStatusList,
        orderType,
        leftBillNum,
        rightBillNum,
        rightMemberOverdueDayNum,
        leftMemberOverdueDayNum,
        isPrepay,
        lockStatus,
        storeBusinessUserName,
        isFupBill,
      };
      if (activeStatus != 0) params.status = activeStatus - 0;
      if (timeSlotFinal && timeSlotFinal.length > 0) {
        params.leftFinalPayDate = timeSlotFinal[0];
        params.rightFinalPayDate = timeSlotFinal[1];
      }
      if (timeSlotBill && timeSlotBill.length > 0) {
        params.leftBillDate = timeSlotBill[0];
        params.rightBillDate = timeSlotBill[1];
      }
      if (timeSlotOrder && timeSlotOrder.length > 0) {
        params.leftOrderDate = timeSlotOrder[0];
        params.rightOrderDate = timeSlotOrder[1];
      }
      if (timeSlotLock && timeSlotLock.length > 0) {
        params.leftLockDate = timeSlotLock[0];
        params.rightLockDate = timeSlotLock[1];
      }
      if (keywordName) params[keywordName] = keywordValue;
      DownloadAPI(params);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
  padding: 20px;
  min-height: calc(100vh - 84px);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
    pointer-events: none;
    z-index: 0;
  }
}

// 页面标题区域
.page-header {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
  }
  
  .page-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1a1e25;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: -0.5px;
    
    .title-icon {
      font-size: 24px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
  
  .header-stats {
    display: flex;
    gap: 24px;
    
    .stat-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      padding: 4px 14px;
      background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
      border-radius: 10px;
      border: 1px solid rgba(64, 158, 255, 0.15);
      
      .stat-label {
        font-size: 12px;
        color: #909399;
        margin-right: 8px;
      }
      
      .stat-value {
        font-size: 16px;
        font-weight: 700;
        color: #409EFF;
        line-height: 1;
      }
    }
  }
}

// 卡片标题样式
.card-header-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f2f5;
  
  i {
    font-size: 18px;
    color: #409EFF;
  }
}

// 搜索卡片样式
.search-card {
  margin-bottom: 20px;
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 24px 28px;
  }

  .header-search {
    .search-header {
      .el-form-item {
        margin-right: 15px;
        margin-bottom: 10px;
        
        .el-form-item__label {
          color: #303133;
          font-weight: 600;
          letter-spacing: 0.3px;
          font-size: 14px;
          position: relative;
          
          &::after {
            content: ':';
            margin-left: 2px;
            color: #909399;
          }
        }
        
        .el-input,
        .el-select {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          
          .el-input__inner {
            border-radius: 10px;
            height: 38px;
            line-height: 38px;
            border: 1.5px solid #E4E7ED;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            background: #fafbfc;
            font-size: 13px;

            &:hover {
              border-color: #C0C4CC;
              background: #ffffff;
            }
          }
          
          &.is-active .el-input__inner,
          .el-input__inner:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
            background: #ffffff;
          }
        }
        
        .el-select {
          .el-input__inner {
            border-radius: 10px;
          }
        }
        
        .el-date-editor {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          
          .el-range-separator {
            padding: 0 10px;
            color: #606266;
            font-weight: 500;
          }
          
          .el-range-input {
            width: 35%;
            font-size: 13px;
          }
          
          .el-input__inner {
            border-radius: 10px;
            height: 38px;
            border: 1.5px solid #E4E7ED;
            background: #fafbfc;
          }
          
          &:hover .el-input__inner {
            border-color: #C0C4CC;
            background: #ffffff;
          }

          &.is-active,
          &:focus-within {
            box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
            border-radius: 10px;
            
            .el-input__inner {
              background: #ffffff;
            }
          }
        }
        
        .el-input-number {
          .el-input__inner {
            border-radius: 10px;
            height: 38px;
            border: 1.5px solid #E4E7ED;
            background: #fafbfc;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            
            &:hover {
              border-color: #C0C4CC;
              background: #ffffff;
            }
            
            &:focus {
              border-color: #409EFF;
              box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
              background: #ffffff;
            }
          }
        }
      }
      
      .kw {
        .el-input,
        .el-select {
          width: 320px;
        }
        .el-select .el-input {
          width: 100px;
        }
        .el-select {
          width: 110px;
        }
        .input-with-select {
          vertical-align: middle;
          
          .el-input-group__prepend {
            background-color: #fff;
            border-radius: 10px 0 0 10px;
          }
          
          .el-input__inner {
            border-radius: 0 10px 10px 0;
          }
        }
      }
      
      .search-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
        border: none;
        box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover {
          background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
          box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
        }
      }

      .reset-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
        border: none;
        box-shadow: 0 4px 12px rgba(144, 147, 153, 0.25);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover {
          background: linear-gradient(135deg, #909399 0%, #82848a 100%);
          box-shadow: 0 6px 16px rgba(144, 147, 153, 0.35);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
        }
      }
    }
  }
}

// 标签页卡片样式
.tab-card {
  margin-bottom: 20px;
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #67C23A 0%, #85ce61 50%, #95d475 100%);
  }

  ::v-deep .el-card__body {
    padding: 16px 24px;
  }

  .header-tab {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    .left-tab {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
      
      .tab-item,
      .select-tab {
        cursor: pointer;
        padding: 8px 16px;
        border-radius: 8px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        font-size: 14px;
        font-weight: 500;
        color: #606266;
        position: relative;
        
        &:hover {
          background: #f5f7fa;
          color: #409EFF;
        }
      }
      
      .select-tab {
        color: #409EFF;
        background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
        font-weight: 600;
        
        &::after {
          content: '';
          position: absolute;
          bottom: -16px;
          left: 50%;
          transform: translateX(-50%);
          width: 60%;
          height: 3px;
          background: linear-gradient(90deg, #409EFF 0%, #66b1ff 100%);
          border-radius: 2px 2px 0 0;
        }
      }
    }
    
    .tab-actions {
      display: flex;
      gap: 10px;
      
      .export-today-btn {
        border-radius: 10px;
        padding: 8px 20px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #e6a23c 0%, #f39c12 100%);
        border: none;
        box-shadow: 0 4px 14px rgba(230, 162, 60, 0.35), 0 2px 6px rgba(230, 162, 60, 0.2);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover {
          background: linear-gradient(135deg, #f39c12 0%, #d68910 100%);
          box-shadow: 0 6px 20px rgba(230, 162, 60, 0.45), 0 3px 8px rgba(230, 162, 60, 0.25);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(230, 162, 60, 0.3);
        }
      }
      
      .export-btn {
        border-radius: 10px;
        padding: 8px 20px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
        border: none;
        box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover {
          background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
          box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
        }
      }
    }
  }
}

// 表格卡片样式
.table-card {
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #67C23A 0%, #85ce61 50%, #95d475 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 24px;
  }

  ::v-deep .tp-table {
    .el-table {
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid #EBEEF5;
      background: #ffffff;

      th {
        background: linear-gradient(180deg, #F8FAFF 0%, #F0F4FF 100%);
        color: #303133;
        font-weight: 700;
        padding: 18px 0;
        border-bottom: 2px solid #E4E7ED;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        font-size: 12px;
        
        &:first-child {
          padding-left: 20px;
        }
      }

      tbody {
        tr {
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          border-bottom: 1px solid #F0F2F5;

          &:hover > td {
            background: linear-gradient(90deg, #F5F7FA 0%, #FAFBFC 100%) !important;
          }
          
          &:last-child {
            border-bottom: none;
          }

          td {
            padding: 18px 0;
            border-bottom: 1px solid #F5F7FA;
            
            &:first-child {
              padding-left: 20px;
            }
          }
        }
      }
    }

    .table-cell-text {
      margin: 0;
      color: #606266;
      font-size: 13px;
      line-height: 1.8;
      font-weight: 400;
    }
    
    // 表格内容区域样式
    td {
      div, p {
        font-size: 13px;
        line-height: 1.8;
        color: #606266;
        margin-bottom: 4px;
        
        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .pagination {
      margin-top: 24px;
      padding: 20px 0 0;
      border-top: 2px solid #F0F2F5;
      
      ::v-deep .el-pagination {
        .el-pagination__total {
          color: #606266;
          font-weight: 500;
        }
        
        .btn-prev,
        .btn-next {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            background: #F5F7FA;
            color: #409EFF;
          }
        }
        
        .el-pager li {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            color: #409EFF;
            background: #F5F7FA;
          }
          
          &.active {
            background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
            color: #ffffff;
            font-weight: 600;
            box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
          }
        }
        
        .el-select .el-input__inner {
          border-radius: 6px;
          border-color: #DCDFE6;
          
          &:hover {
            border-color: #C0C4CC;
          }
        }
        
        .el-input__inner {
          border-radius: 6px;
          border-color: #DCDFE6;
          
          &:hover {
            border-color: #C0C4CC;
          }
          
          &:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .search-card .header-search .search-header ::v-deep {
    .el-form-item {
      margin-right: 12px;
    }
  }
  
  .page-header .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    
    .header-stats {
      width: 100%;
      justify-content: flex-start;
    }
  }
}

@media (max-width: 768px) {
  .wrapper {
    padding: 12px;
  }
  
  .page-header .header-content {
    padding: 16px;
    
    .page-title {
      font-size: 20px;
    }
  }
  
  .search-card,
  .tab-card,
  .table-card {
    border-radius: 12px;
    
    ::v-deep .el-card__body {
      padding: 16px;
    }
  }
  
  .tab-card .header-tab {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    
    .left-tab {
      width: 100%;
      overflow-x: auto;
    }
  }
}
</style>
